export enum DetailsControlState {
  Default = '',
  Highlighted = 'highlighted', // slightly highlight control via backgroud color
  Focused = 'focused', // sets focused styles according on control status
  Masked = 'masked', // mask control by reducing opacity
}
